<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [width]="700"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>

  <form [formGroup]="form">

    <div class="dialog-line">
      <div class="label" title="JoursFeries">Jours Fériés</div>
      <div class="value">
        <yo-lookup
          [data]="jourFerieList"
          [selectedItem]="selectedJourFerie"
          [showClearButton]="true"
          [key]="'code'"
          displayValue="libelle"
          autoSelect="false"
          [placeholder]="'Pre-sélection d\'un jour férié'"
          (onValueChange)="onChangeJourFerie($event)"
        ></yo-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Libelle">Libellé <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box placeholder="Libellé" formControlName="libelle"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Code">Code <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box placeholder="Code" formControlName="code"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="DateFermeture">Date de fermeture <span class="danger-color">*</span></div>
      <div class="value">
        <dx-date-box
          title="Choisissez la date de fermeture (JJ/MM)"
          [(value)]="selectedDatefermeture"
          displayFormat="dd/MM"
          type="date"
        >
        </dx-date-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Perimetre">Périmètres concernés <span class="danger-color">*</span></div>
      <div class="value">
        <yo-tagbox
          #perimetresFermeturesTag
          [data]="perimetreFermetureList"
          [selectedItems]="selectedPerimetreFermetureList"
          [key]="'code'"
          displayValue="code"
          [placeholder]="'Sélection des périmètres'"
          (onValueChange)="onChangePerimetreFermeture($event)">
        </yo-tagbox>
      </div>
    </div>

    <div><span><i class="fas fa-info-circle mg-r-5"></i> Le lundi de Pâques, l'Ascension, le lundi de Pentecôte et le vendredi Saint (Alsace), sont à créer manuellement, car leurs dates évoluent chaque année. </span>
    </div>
  </form>

  <div class="custom-button-container-right">
    <yo-button
      type="submit"
      iconClass="fas fa-save"
      [theme]="ButtonThemeEnum.SAVE"
      tooltip="Enregistrer"
      (onClick)="save()">
    </yo-button>
    <yo-button
      (onClick)="closeDialog()"
      tooltip="Fermer"
      iconClass="fas fa-times"
      [theme]="ButtonThemeEnum.CANCEL">
    </yo-button>
  </div>

</dx-popup>
